import axios from "axios";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

// axios.defaults.baseURL = "https://hate-speech-backend.onrender.com";
// axios.defaults.baseURL = "http://127.0.0.1:5000";
axios.defaults.baseURL = "https://hate-speech-detector-server.onrender.com";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
